import React from 'react';
import cls from 'classnames';
import makeIconName from '../../../../utils/makeIconName';
import { isTodayDay, getMonthStr, isEarlySelected, isDayNotClickable, formatDateDash } from '../../../../utils/dateUtils';
import { DAY_NAMES } from '../../../../constants/dates';
import { ICONS } from '../../../../constants/icons';
import makeBodyText from '../../../../utils/makeText';
import styles from './index.module.scss';
const DayPicker = ({ changeMonth, setMode, setYearsIndex, handleSelect, value, year, month, monthDays, isPayCheck, minDate, maxDate, name, earlySelectedDates }) => {
    const isDayDisabled = (day) => {
        if (!isPayCheck) {
            return false;
        }
        return isDayNotClickable(day, minDate, maxDate);
    };
    const _handleDayClick = (day) => {
        if (isDayDisabled(day) || isEarlySelected({ earlySelectedDates, day })) {
            return false;
        }
        if (day._month !== 0) {
            return changeMonth(day._month);
        }
        return handleSelect(day.timestamp);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.head },
            React.createElement("button", { id: `${name}-prev-month-btn`, type: 'button', "aria-label": 'Previous month', className: cls(makeIconName(ICONS.x24.arrow_left, 'x24'), styles.controls), onClick: () => changeMonth(-1) }),
            React.createElement("div", null,
                React.createElement("button", { type: 'button', className: styles.month, onClick: () => setMode('month') }, getMonthStr(month)),
                React.createElement("button", { type: 'button', onClick: () => {
                        setYearsIndex(0);
                        setMode('year');
                    } }, year)),
            React.createElement("button", { id: `${name}-next-month-btn`, type: 'button', "aria-label": 'Next month', className: cls(makeIconName(ICONS.x24.arrow_right, 'x24'), styles.controls), onClick: () => changeMonth(1) })),
        React.createElement("div", { className: styles.days }, DAY_NAMES.map((day) => (React.createElement("p", { className: cls(makeBodyText('S'), styles.day), key: day }, day)))),
        React.createElement("div", { className: styles.days }, monthDays.map((day) => (React.createElement("div", { className: cls(styles.item, {
                disabled: isDayDisabled(day),
                [styles.prevMonth]: day._month < 0,
                [styles.nextMonth]: day._month > 0,
                [styles.anotherMonth]: day._month !== 0,
                [styles.selected]: day.timestamp === value,
                [styles.today]: isTodayDay(day.timestamp),
                [styles.isDisabled]: isDayDisabled(day),
                [styles.earlySelected]: isEarlySelected({ earlySelectedDates, day }),
                [styles.todayPayCheck]: isPayCheck && isTodayDay(day.timestamp)
            }), key: `${day.date} ${day.timestamp}` },
            React.createElement("button", { id: formatDateDash(day.timestamp), type: 'button', onClick: () => _handleDayClick(day) }, day.date)))))));
};
export default DayPicker;
